import { createSlice } from "@reduxjs/toolkit";
import {
  fetchSubCategorys,
  fetchSubCategoryById,
  updateSubCategory,
  updateStatusInSubCategory,
  fetchSuCategoryBasedOnSelectedCategory
} from "./thunk";

interface SubCategoryState {
  subCategoryList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
  subCategoryOptions: []
}

const initialState: SubCategoryState = {
  subCategoryList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
  subCategoryOptions: []
};

const subCategorySlice = createSlice({
  name: "subCategory",
  initialState,
  reducers: {
     resetSubCategoryOptions: (state) => {
      state.subCategoryOptions = [];
    },
  },
  extraReducers: (builder) => {
    builder

       // SubCategory DropDown options
        .addCase(fetchSuCategoryBasedOnSelectedCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSuCategoryBasedOnSelectedCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.subCategoryOptions = action.payload;
      })
      .addCase(fetchSuCategoryBasedOnSelectedCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchSubCategorys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubCategorys.fulfilled, (state, action) => {
        state.loading = false;
        state.subCategoryList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchSubCategorys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Categories";
      })
      .addCase(fetchSubCategoryById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubCategoryById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchSubCategoryById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateSubCategory.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.subCategoryList = state.subCategoryList.map((category) =>
          category.id === action.payload.id ? action.payload : category
        );
      })
      .addCase(updateSubCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInSubCategory.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.subCategoryList = state.subCategoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInSubCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});
export const { resetSubCategoryOptions } = subCategorySlice.actions;
export default subCategorySlice.reducer;
